import type { AxiosError } from 'axios';
import { Api, type IOperation, type IQueryOption } from '__generated__';
import { api, apiStatic } from 'AurionCR/components/helpers';

/** Mutations: Create, Patch, Delete — trigger SOURCES_UPDATE via `api` */
export const API = new Api();
API.instance = api;

/** Reads: GetAllDynamic and other list fetches — use `apiStatic` */
export const APIRead = new Api();
APIRead.instance = apiStatic;

export interface IDynamicResult<T> {
  value: T[];
  count?: number;
}

export async function getAllDynamic<T>(
  call: (body: Partial<IQueryOption>) => Promise<{ data: T[] | IDynamicResult<T> }>,
  options: Partial<IQueryOption>,
): Promise<IDynamicResult<T>> {
  const { data } = await call(options);
  if (Array.isArray(data)) {
    return { value: data };
  }
  return data as IDynamicResult<T>;
}

/** wiz patch interceptor expects plain object, not IOperation[] */
export type PatchBody<T> = Partial<T>;

export function asPatchBody<T>(data: PatchBody<T>): IOperation[] {
  return data as unknown as IOperation[];
}

export const normalizeError = (error: unknown): Error | AxiosError => {
  if (error instanceof Error) {
    return error;
  }
  if (error && typeof error === 'object' && 'isAxiosError' in error) {
    return error as AxiosError;
  }
  return new Error(String(error));
};
